import ShoppingCenter from './main';
import EditModelPage from './editModel';

const routes = [
  {
    path: '/*',
    Component: ShoppingCenter,
    props: {},
  },
  {
    path: '/:id/edit-model/*',
    Component: EditModelPage,
    props: {},
  },
  {
    path: '/:id/*',
    Component: ShoppingCenter,
    props: {},
  },
];

export default routes;
